module.exports = __webpack_public_path__ + "img/gzh.2de49a4f.png";